electronCallback:
  title:
    loading: 登录中
    openingAiri: 正在打开Life
    signedIn: 登录成功
    signInFailed: 登录失败
    finishSignInInAiri: 登录完成
    openAiriToContinue: 打开Life以继续
  message:
    checkingResponse: 正在检查鉴权是否有效，并准备将登录状态转交给 Life...
    passingToAiri: 正在将登录状态转交至 Life 客户端。本页面即将自动关闭...
    syncedAndSafeToClose: 我们已经通知 Life 客户端你登录成功啦～
    invalidResponse: 我们暂时无法验证本次登录的有效性，要重新试试看吗？
    loopbackUnreachable: 暂时无法通知 Life，原因是无法与本地的 Life 通信，要重启 Life 试试吗？
    tryOpenDirectly: 我们正在尝试通知 Life 客户端登录结果，如果仍没有登录，试试看点击下方的按钮～
    automaticHandoffFailed: 自动登录到本地客户端失败了，要重新试试吗？
  label:
    signIn: 登录
    safeToClose: 现在可以安全地关闭此标签页了。
    whyStillHere: 为什么这个标签页仍在这里？
  action:
    openAiriManually: 手动打开 Life
  hint:
    closeTabManually: 一些浏览器不允许自动关闭这个页面，你可以手动关掉它。
signIn:
  title: 登录
  step:
    identify:
      heading: 登录
      description: 输入电子邮箱以登录或创建账户
    password:
      heading: 欢迎回来
      description: 以 {email} 继续登录
    create:
      heading: 创建账户
      description: 我们将为 {email} 创建一个新账户...
  email:
    label: 邮箱
    placeholder: you{'@'}example.com
  password:
    label: 密码
    placeholder: 您的密码
  newPassword:
    label: 创建密码
    placeholder: 至少 8 个字符
  confirmPassword:
    label: 确认密码
    placeholder: 重新输入密码
  name:
    label: 昵称
    placeholder: 可选，默认使用邮箱名称
  action:
    continue: 继续
    signIn: 登录
    createAccount: 创建账户
    forgotPassword: 忘记密码？
    useDifferentEmail: 使用其他邮箱
  divider:
    or: 或
  error:
    fallback: 登录失败
    unknown: 发生了未知错误
    socialOnlyNoPassword: 此邮箱通过 Google 或 GitHub 注册。请使用下方按钮登录；登录后可在账户设置中添加密码。
    passwordMismatch: 密码与确认密码不一致。
    invalidEmail: 请输入有效格式的电子邮件地址
  footer:
    prefix: 继续之前，你需要同意我们的
    terms: 服务条款
    and: 和
    privacy: 隐私政策
verifyEmail:
  title:
    pending: 请检查您的收件箱，如果没有找到，可以再检查一下 Spam（垃圾信箱）
    success: 邮箱验证成功！
    failed: 验证失败
  message:
    pending: 我们向您输入的电子邮箱发送了一个验证链接。要继续登入或注册步骤，请点开链接以继续。
    pendingWithAddress: 我们已向 {email} 发送验证链接。打开链接即可完成账户创建；点击后此页面会自动继续。
    success: 邮箱已验证，您已登录。现在可以关闭此标签页。
    failed: 无法验证您的邮箱（{error}）。请尝试重新申请链接。
  action:
    backToSignIn: 返回登录
forgotPassword:
  title: 重置密码
  description: 输入与账户关联的邮箱，我们会向您发送重置链接。
  email:
    label: 邮箱
    placeholder: you{'@'}example.com
  action:
    send: 发送重置链接
    backToSignIn: 返回登录
  message:
    sent: 如果 {email} 对应一个账户，重置链接正在发送。
  error:
    fallback: 无法发送重置邮件。
deleteAccount:
  title:
    success: 帐户已删除
    failed: 无法删除账户
  message:
    success: 您的账户已删除。
  action:
    closeTab: 您可以关闭此标签页。
resetPassword:
  title:
    default: 设置新密码
    success: 密码已更新
  password:
    label: 新密码
    placeholder: 至少 8 个字符
  confirmPassword:
    label: 确认新密码
    placeholder: 重新输入新密码
  action:
    reset: 更新密码
    goSignIn: 前往登录
  message:
    success: 密码已更新，请使用新密码登录。
  error:
    fallback: 无法更新密码。
    missingToken: 重置链接无效或已过期。
    passwordMismatch: 密码和确认密码不匹配。
profile:
  title: 账户资料
  description: 管理您的头像、显示名称和关联的帐户。
  section:
    profile: 个人资料
    avatar: 头像
    password: 密码
    linkedAccounts: 已关联的账户
  field:
    email: 邮箱
    emailVerified: 邮箱状态
    createdAt: 加入时间
  label:
    verified: 已验证
    unverified: 未验证
  name:
    label: 昵称
    placeholder: 别人如何看到你
  avatar:
    altText: 头像
    gravatarNotice: 头像来自 Gravatar。
    gravatarLink: 在 gravatar.com 管理
  password:
    currentLabel: 当前密码
    currentPlaceholder: 输入您当前的密码
    newLabel: 新密码
    newPlaceholder: 至少 8 个字符
    confirmLabel: 确认新密码
    confirmPlaceholder: 重新输入新密码
    setDescription: 您通过第三方服务登录，因此暂未设置密码。我们会通过邮件发送安全链接供您设置密码。
    setLinkSent: 请查看 {email} 收件箱中的密码设置链接。
    setLinkFailed: 无法发送密码设置链接。
  linkedAccounts:
    description: 可通过这些服务登录 Life。取消关联会撤销访问权限，之后可关联其他账户。
    status:
      linked: 已关联
      notLinked: 未关联
      linkedSince: 关联于 {date}
    action:
      link: 关联
      unlink: 取消关联
    message:
      loading: 正在加载连接的帐户……
      unlinked: '已取消关联 {provider}。'
      linkStarted: 正在跳转到 {provider}…
    error:
      listFailed: 无法加载已关联账户。
      unlinkFailed: 无法取消关联此账户。
      linkFailed: 无法启动关联流程。
      lastAccount: 这是您唯一的登录方式。请先设置密码才能取消链接。
  action:
    saveProfile: 保存更改
    changePassword: 修改密码
    sendSetPasswordLink: 给我发一封邮件以设置密码
    signOut: 退出登录
  message:
    loading: 正在加载您的个人资料……
    profileSaved: 个人资料已更新
    passwordChanged: 密码已更改，其他会话已退出登录。
  error:
    loadFailed: 无法加载您的个人资料。
    saveFailed: 无法保存您的更改。
    changePasswordFailed: 无法更改您的密码。
    signOutFailed: 我们无法将您登出。
    passwordMismatch: 新密码和确认密码不匹配。
    passwordSameAsCurrent: 新密码必须与当前密码不同。
webCallback:
  title:
    signIn: 登录
    errorLabel: 登录中遇到错误
    loading: 正在登录...
  message:
    missingCodeOrState: 缺少授权码或状态
    missingFlowState: 缺少OIDC 流状态-请重新登录
    tokenExchangeFailed: 令牌交换失败
    finalizing: Life登录完成
  action:
    tryAgain: 重试
